import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import {
    Box,
    Typography,
    CircularProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import baseURL from "../../config";
import Navbar from "../../Navbar/Navbar";

const VesselOwnerContracts = () => {
    const { id } = useParams();
    const [contracts, setContracts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [openModal, setOpenModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [modalDocuments, setModalDocuments] = useState([]);

    const fetchContracts = async () => {
        try {
            const response = await axios.get(`${baseURL}/api/vesselOwner/getcontractforvesselownerafterForm1/${id}`);
           
                setContracts(response.data.data);
                // console.log("Contracts:", response.data.data);
            
        } catch (error) {
            console.error("Error fetching contracts:", error);
            setError("Failed to fetch contracts.");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchContracts();
    }, [id]);

    const handleOpenModal = (title, documents) => {
        setModalTitle(title);
        setModalDocuments(documents);
        setOpenModal(true);
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="60vh">
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box textAlign="center" mt={4}>
                <Typography color="error">{error}</Typography>
            </Box>
        );
    }

    return (
        <>
            <Navbar />
            <Box p={3}>
                <Typography variant="h4" gutterBottom>
                    Vessel Owner Contracts
                </Typography>

                {contracts.length === 0 ? (
                    <Typography>No contracts found for this vessel owner.</Typography>
                ) : (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>#</TableCell>
                                    <TableCell>Vessel Details</TableCell>
                                    <TableCell>Crew Info</TableCell>
                                    <TableCell>Crewing Agent</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {contracts.map((contract, index) => (
                                    <TableRow key={`${contract._id}-${index}`}>
                                        <TableCell>{index + 1}</TableCell>

                                        {/* Vessel Details */}
                                        <TableCell>
                                            <Box sx={{ fontSize: "0.85rem", display: "flex", flexDirection: "column", gap: "4px" }}>
                                                <Typography><strong>Company:</strong> {contract.contractId?.vesselOwnerName || "N/A"}</Typography>
                                                <Typography><strong>Vessel:</strong> {contract.contractId?.vesselName || "N/A"}</Typography>
                                                <Typography>
                                                    <strong>Contract Created At:</strong>{" "}
                                                    {new Date(contract.createdAt).toLocaleDateString("en-GB", {
                                                        day: "numeric",
                                                        month: "short",
                                                        year: "numeric",
                                                    })}{" "}
                                                    {new Date(contract.createdAt).toLocaleTimeString("en-US", {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        second: "2-digit",
                                                        hour12: true,
                                                    })}
                                                </Typography>

                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    sx={{ alignSelf: "flex-start", mt: 1 }}
                                                    onClick={() =>
                                                        handleOpenModal(
                                                            "Vessel Documents",
                                                            ["pipolicydocument", "maritimelabourconvention", "fsdocument", "dmlcp1", "dmlc2"].map((doc) => ({
                                                                name: doc.replace(/([A-Z])/g, " $1"),
                                                                filePath: contract?.contractId?.ShipDetails?.[doc]?.filePath || null,
                                                            }))
                                                        )
                                                    }
                                                >
                                                    Vessel Files
                                                </Button>
                                            </Box>
                                        </TableCell>

                                        {/* Crew Info */}
                                        <TableCell>
                                            <Typography sx={{ fontSize: "0.85rem" }}><strong>Name:</strong> {contract.contractId?.crewName || "N/A"}</Typography>
                                            {/* <Typography sx={{ fontSize: "0.85rem" }}><strong>Indos No.:</strong> {contract.contractId?.indosno || "N/A"}</Typography> */}
                                            {/* <Typography sx={{ fontSize: "0.85rem" }}><strong>Email:</strong> {contract.contractId?.email || "N/A"}</Typography> */}
                                            <Typography sx={{ fontSize: "0.85rem" }}><strong>Rank:</strong> {contract.contractId?.rankName || "N/A"}</Typography>

                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                onClick={() =>
                                                    handleOpenModal(
                                                        "Crew Documents",
                                                        [
                                                            { key: "crewDocument", label: "Crew Document" },
                                                            { key: "passportDocument", label: "Passport" },
                                                            { key: "cdcDocument", label: "CDC" },
                                                            { key: "iloDocument", label: "ILO" },
                                                            { key: "stcwDocument", label: "STCW" },
                                                            { key: "stsdsdDocument", label: "STSDSD" },
                                                            { key: "CrewPhotoDocument", label: "Crew Photo" },
                                                            { key: "yellowfeverDocument", label: "Yellow Fever" },
                                                            { key: "CovidVaccineDocument", label: "COVID Vaccine" },
                                                            { key: "watchkeepingDocument", label: "Watchkeeping" },
                                                            { key: "CopDocument", label: "COP" },
                                                            { key: "cookcocDocument", label: "Cook COC" },
                                                            { key: "officercocDocument", label: "Officer COC" },
                                                            { key: "gocDocument", label: "GOC" },
                                                            { key: "gmdssDocument", label: "GMDSS" },
                                                            { key: "h2sDocument", label: "H2S" },
                                                            { key: "huetDocument", label: "HUET" },
                                                            { key: "highvoltageDocument", label: "High Voltage" },
                                                            { key: "brmDocument", label: "BRM" },
                                                            { key: "degreeDiplomaDocument", label: "Degree/Diploma" },
                                                            { key: "bosietDocument", label: "BOSIET" },
                                                            { key: "signContratDocument", label: "Signed Contract" },
                                                            // { key: "visaDocument", label: "Visa" },
                                                            // { key: "ticketDocument", label: "Ticket" },
                                                            { key: "pscrbDocument", label: "PSCRB" },
                                                            { key: "sidDocument", label: "SID" },
                                                            { key: "AFF", label: "Advanced Fire Fighting (AFF)" },
                                                            { key: "MFA", label: "Medical First Aid (MFA)" },
                                                            { key: "PSSR", label: "Personal Safety and Social Responsibility (PSSR)" },
                                                            { key: "SSO", label: "Ship Security Officer (SSO)" },
                                                            { key: "BTM", label: "Bridge Team Management (BTM)" },
                                                            { key: "ECDIS", label: "ECDIS" },
                                                            { key: "contract", label: "Contract" },
                                                            { key: "BankDocument", label: "Bank Details" },
                                                          ].map((doc) => ({
                                                            name: doc.label,
                                                            filePath: contract?.contractId?.crewdetails?.[doc.key]?.filePath || null,
                                                        }))
                                                    )
                                                }
                                            >
                                                Crew Files
                                            </Button>
                                        </TableCell>

                                        {/* Crewing Agent */}
                                        <TableCell>
  <Box display="flex" flexDirection="column" alignItems="start">
    <Typography sx={{ mb: 1, maxWidth: "175px", wordBreak: "break-word" }}>
      {contract?.contractId?.crewingAgent?.agentName || "N/A"}
    </Typography>

    {/* {(() => {
      const documentTypes = [
        "BSM", "RPSL", "NOK", "DrugAlcoholPolicy",
        "CheckList", "DeclarationForm", "TravelTicket",
        "Visa", "LOG", "SignedContract"
      ];

      const uploadedDocuments = documentTypes
        .filter(type => contract?.[type]?.filePath)
        .map(type => ({
          name: type,
          filePath: contract[type].filePath
        }));

      return (
        <Button
          variant="contained"
          color="primary"
          disabled={uploadedDocuments.length === 0}
          onClick={() =>
            handleOpenModal("Crewing Agent Documents", uploadedDocuments)
          }
        >
          Documents
        </Button>
      );
    })()} */}
  </Box>
</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Box>

            {/* Modal */}
            <Dialog open={openModal} onClose={() => setOpenModal(false)} fullWidth>
                <DialogTitle>{modalTitle}</DialogTitle>
                <DialogContent>
                    {modalDocuments.length > 0 ? (
                        modalDocuments.map((doc, index) => (
                            <Paper
                                key={index}
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    p: 2,
                                    mb: 2,
                                }}
                            >
                                <Box display="flex" alignItems="center">
                                    <PictureAsPdfIcon sx={{ color: "red", mr: 1 }} />
                                    <Typography>{doc.name}</Typography>
                                </Box>
                                {doc.filePath ? (
                                    <Button
                                        variant="contained"
                                        href={doc.filePath.startsWith("http") ? doc.filePath : `${baseURL}/${doc.filePath.replace(/\\/g, "/")}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Download
                                    </Button>
                                ) : (
                                    <Box display="flex" alignItems="center">
                                        <ReportProblemIcon sx={{ color: "orange", mr: 1 }} />
                                        <Typography color="error">No File Available</Typography>
                                    </Box>
                                )}
                            </Paper>
                        ))
                    ) : (
                        <Typography textAlign="center" color="textSecondary">
                            No documents available
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenModal(false)}>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default VesselOwnerContracts;
